import SiteLogo from "@/components/site-logo"
import MainMenu from "@/components/main-menu"
import React, {ReactNode, useEffect, useState} from "react"
import useAuth from "@/library/auth/_hook.auth"
import {useRouterState} from "@tanstack/react-router"

export default function MobileToolbarWrapper({children}: {children?: ReactNode}) {
    const {logout} = useAuth()
    const [isShown, setIsShown] = useState(false)
    const selected = useRouterState({
        select: (state) => state.status
    })

    useEffect(() => {
        closeMenu()
    }, [selected])

    const toggleMenu = () => {
        setTimeout(() => {
            setIsShown(current => !current)
        }, 100)
    }

    const closeMenu = () => {
        setIsShown(() => false)
    }

    return <>
        {!isShown && children}
        <div className="mobile-toolbar-wrapper tablet-and-down">
            <ul className="mobile-toolbar">
                <li><a href="#" onClick={e => {
                    e.preventDefault()

                    toggleMenu()
                }}><i className="fas fa-bars"/></a></li>
                <li><a href="#" onClick={() => {
                    closeMenu()
                }}><i className="fas fa-magnifying-glass"/></a></li>
                <li><a href="#" onClick={() => {
                    logout()
                    closeMenu()
                }}><i className="fas fa-user"/></a></li>
            </ul>

            {isShown && <div className="menu-container">
                <SiteLogo/>
                <MainMenu mode="vertical"/>
            </div>}
        </div>
    </>
}
